import type { ThemeTokens } from "@yamada-ui/core"

export const gradients: ThemeTokens = {}
